var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBook = function SvgBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "M1.8 3.6c1.7-.9 4.8-.6 7.1.8-.06 3.6.06 7.3 0 10.8-2.3-1.4-5.1-1.6-7.2-.7.06-3.6.02-7.4.1-10.9"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "M16.2 3.5c-1.7-.8-4.9-.4-7.2.9-.1 3.5 0 7.4-.1 10.8 2.3-1.3 5.2-1.5 7.4-.7-.06-3.6 0-7.5-.1-11"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.9,
    d: "M3.4 6.3c1.1-.4 2.4-.2 3.7.4M3.3 8.6c1.3-.4 2.6-.2 3.9.4M3.4 10.9c1-.3 2-.2 3 .2M10.8 6.7c1.2-.6 2.5-.8 3.7-.4M10.9 9c1.2-.6 2.5-.8 3.7-.4M11.5 11.1c.9-.4 2-.5 3-.2"
  }))));
};
export default SvgBook;